const COUNTRY_CODE_EN = Object.freeze({
  AND: 'Andorra',
  ARE: 'United Arab Emirates',
  AFG: 'Afghanistan',
  ATG: 'Antigua and Barbuda',
  AIA: 'Anguilla',
  ALB: 'Albania',
  ARM: 'Armenia',
  AGO: 'Angola',
  ATA: 'Antarctica',
  ARG: 'Argentina',
  ASM: 'American Samoa',
  AUT: 'Austria',
  AUS: 'Australia',
  ABW: 'Aruba',
  ALA: 'Aland',
  AZE: 'Azerbaijan',
  BIH: 'Bosnia and Herzegovina',
  BRB: 'Barbados',
  BGD: 'Bangladesh',
  BEL: 'Belgium',
  BFA: 'Burkina Faso',
  BGR: 'Bulgaria',
  BHR: 'Bahrain',
  BDI: 'Burundi',
  BEN: 'Benin',
  BLM: 'Saint Barthélemy',
  BMU: 'Bermuda',
  BRN: 'Brunei',
  BOL: 'Bolivia',
  BES: 'Bonaire',
  BRA: 'Brazil',
  BHS: 'Bahamas',
  BTN: 'Bhutan',
  BVT: 'Bouvet Island',
  BWA: 'Botswana',
  BLR: 'Belarus',
  BLZ: 'Belize',
  CAN: 'Canada',
  CCK: 'Cocos [Keeling] Islands',
  COD: 'Democratic Republic of the Congo',
  CAF: 'Central African Republic',
  COG: 'Republic of the Congo',
  CHE: 'Switzerland',
  CIV: 'Ivory Coast',
  COK: 'Cook Islands',
  CHL: 'Chile',
  CMR: 'Cameroon',
  CHN: 'China',
  COL: 'Colombia',
  CRI: 'Costa Rica',
  CUB: 'Cuba',
  CPV: 'Cape Verde',
  CUW: 'Curacao',
  CXR: 'Christmas Island',
  CYP: 'Cyprus',
  CZE: 'Czechia',
  DEU: 'Germany',
  DJI: 'Djibouti',
  DNK: 'Denmark',
  DMA: 'Dominica',
  DOM: 'Dominican Republic',
  DZA: 'Algeria',
  ECU: 'Ecuador',
  EST: 'Estonia',
  EGY: 'Egypt',
  ESH: 'Western Sahara',
  ERI: 'Eritrea',
  ESP: 'Spain',
  ETH: 'Ethiopia',
  FIN: 'Finland',
  FJI: 'Fiji',
  FLK: 'Falkland Islands',
  FSM: 'Micronesia',
  FRO: 'Faroe Islands',
  FRA: 'France',
  GAB: 'Gabon',
  GBR: 'United Kingdom',
  GRD: 'Grenada',
  GEO: 'Georgia',
  GUF: 'French Guiana',
  GGY: 'Guernsey',
  GHA: 'Ghana',
  GIB: 'Gibraltar',
  GRL: 'Greenland',
  GMB: 'Gambia',
  GIN: 'Guinea',
  GLP: 'Guadeloupe',
  GNQ: 'Equatorial Guinea',
  GRC: 'Greece',
  SGS: 'South Georgia and the South Sandwich Islands',
  GTM: 'Guatemala',
  GUM: 'Guam',
  GNB: 'Guinea-Bissau',
  GUY: 'Guyana',
  HKG: 'Hong Kong, China',
  HMD: 'Heard Island and McDonald Islands',
  HND: 'Honduras',
  HRV: 'Croatia',
  HTI: 'Haiti',
  HUN: 'Hungary',
  IDN: 'Indonesia',
  IRL: 'Ireland',
  ISR: 'Israel',
  IMN: 'Isle of Man',
  IND: 'India',
  IOT: 'British Indian Ocean Territory',
  IRQ: 'Iraq',
  IRN: 'Iran',
  ISL: 'Iceland',
  ITA: 'Italy',
  JEY: 'Jersey',
  JAM: 'Jamaica',
  JOR: 'Jordan',
  JPN: 'Japan',
  KEN: 'Kenya',
  KGZ: 'Kyrgyzstan',
  KHM: 'Cambodia',
  KIR: 'Kiribati',
  COM: 'Comoros',
  KNA: 'Saint Kitts and Nevis',
  PRK: 'North Korea',
  KOR: 'South Korea',
  KWT: 'Kuwait',
  CYM: 'Cayman Islands',
  KAZ: 'Kazakhstan',
  LAO: 'Laos',
  LBN: 'Lebanon',
  LCA: 'Saint Lucia',
  LIE: 'Liechtenstein',
  LKA: 'Sri Lanka',
  LBR: 'Liberia',
  LSO: 'Lesotho',
  LTU: 'Lithuania',
  LUX: 'Luxembourg',
  LVA: 'Latvia',
  LBY: 'Libya',
  MAR: 'Morocco',
  MCO: 'Monaco',
  MDA: 'Moldova',
  MNE: 'Montenegro',
  MAF: 'Saint Martin',
  MDG: 'Madagascar',
  MHL: 'Marshall Islands',
  MKD: 'Macedonia',
  MLI: 'Mali',
  MMR: 'Myanmar [Burma]',
  MNG: 'Mongolia',
  MAC: 'Macao, China',
  MNP: 'Northern Mariana Islands',
  MTQ: 'Martinique',
  MRT: 'Mauritania',
  MSR: 'Montserrat',
  MLT: 'Malta',
  MUS: 'Mauritius',
  MDV: 'Maldives',
  MWI: 'Malawi',
  MEX: 'Mexico',
  MYS: 'Malaysia',
  MOZ: 'Mozambique',
  NAM: 'Namibia',
  NCL: 'New Caledonia',
  NER: 'Niger',
  NFK: 'Norfolk Island',
  NGA: 'Nigeria',
  NIC: 'Nicaragua',
  NLD: 'Netherlands',
  NOR: 'Norway',
  NPL: 'Nepal',
  NRU: 'Nauru',
  NIU: 'Niue',
  NZL: 'New Zealand',
  OMN: 'Oman',
  PAN: 'Panama',
  PER: 'Peru',
  PYF: 'French Polynesia',
  PNG: 'Papua New Guinea',
  PHL: 'Philippines',
  PAK: 'Pakistan',
  POL: 'Poland',
  SPM: 'Saint Pierre and Miquelon',
  PCN: 'Pitcairn Islands',
  PRI: 'Puerto Rico',
  PSE: 'Palestine',
  PRT: 'Portugal',
  PLW: 'Palau',
  PRY: 'Paraguay',
  QAT: 'Qatar',
  REU: 'Réunion',
  ROU: 'Romania',
  SRB: 'Serbia',
  RUS: 'Russia',
  RWA: 'Rwanda',
  SAU: 'Saudi Arabia',
  SLB: 'Solomon Islands',
  SYC: 'Seychelles',
  SDN: 'Sudan',
  SWE: 'Sweden',
  SGP: 'Singapore',
  SHN: 'Saint Helena',
  SVN: 'Slovenia',
  SJM: 'Svalbard and Jan Mayen',
  SVK: 'Slovakia',
  SLE: 'Sierra Leone',
  SMR: 'San Marino',
  SEN: 'Senegal',
  SOM: 'Somalia',
  SUR: 'Suriname',
  SSD: 'South Sudan',
  STP: 'São Tomé and Príncipe',
  SLV: 'El Salvador',
  SXM: 'Sint Maarten',
  SYR: 'Syria',
  SWZ: 'Swaziland',
  TCA: 'Turks and Caicos Islands',
  TCD: 'Chad',
  ATF: 'French Southern Territories',
  TGO: 'Togo',
  THA: 'Thailand',
  TJK: 'Tajikistan',
  TKL: 'Tokelau',
  TLS: 'East Timor',
  TKM: 'Turkmenistan',
  TUN: 'Tunisia',
  TON: 'Tonga',
  TUR: 'Turkey',
  TTO: 'Trinidad and Tobago',
  TUV: 'Tuvalu',
  TWN: 'Taiwan, China',
  TZA: 'Tanzania',
  UKR: 'Ukraine',
  UGA: 'Uganda',
  UMI: 'U.S. Minor Outlying Islands',
  USA: 'United States',
  URY: 'Uruguay',
  UZB: 'Uzbekistan',
  VAT: 'Vatican City',
  VCT: 'Saint Vincent and the Grenadines',
  VEN: 'Venezuela',
  VGB: 'British Virgin Islands',
  VIR: 'U.S. Virgin Islands',
  VNM: 'Vietnam',
  VUT: 'Vanuatu',
  WLF: 'Wallis and Futuna',
  WSM: 'Samoa',
  XKX: 'Kosovo',
  YEM: 'Yemen',
  MYT: 'Mayotte',
  ZAF: 'South Africa',
  ZMB: 'Zambia',
  ZWE: 'Zimbabwe',
});

export { COUNTRY_CODE_EN };
